import lodash from 'lodash'
import moment from 'moment'
import React from 'react'
import styled from 'styled-components'

import {
  FieldPrefix,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import ConfirmationDetails from './ConfirmationDetails'

const Wrapper = styled.div``

const TimeBlock = (props) => {
  const { product, isPickup, isPickupProduct } = props

  const requiresConfirmation = useField('settings.requiresConfirmation')

  const from = useField('settings.from')
  const until = useField('settings.until')
  const hideFromTime = useField('settings.hideFromTime')
  const hideUntilTime = useField('settings.hideUntilTime')
  const additionalService = useField('settings.additionalService')
  const description = lodash.get(additionalService, 'description')
  const recommendedTimeFrom = useField('settings.recommendedTimeFrom')
  const recommendedTimeUntil = useField('settings.recommendedTimeUntil')

  const showBoth = !hideFromTime && !hideUntilTime

  return (
    <Wrapper className="mt-1 mr-4">
      <h6 className="mt-0 text-nowrap">
        {isPickup
          ? i18n.t('header_pickup', 'Abholung')
          : i18n.t('header_delivery', 'Zustellung')}
        {description && <span className="text-muted"> ({description})</span>}
      </h6>
      <div style={{ whiteSpace: 'nowrap' }}>
        <span>
          {isPickup
            ? i18n.t('pickup_time', 'Abholzeit')
            : i18n.t('delivery_time', 'Zustellzeit')}{' '}
        </span>
        {!showBoth && (
          <span>
            {hideFromTime
              ? i18n.t('until_time_lowercase', 'bis')
              : i18n.t('from_time_lowercase', 'ab')}
          </span>
        )}
        <strong>
          {!hideFromTime && moment(from).format('HH:mm')}
          {showBoth && <span>-</span>}
          {!hideUntilTime && moment(until).format('HH:mm')}
        </strong>
      </div>
      {global.isGO && (recommendedTimeFrom || recommendedTimeUntil) && (
        <div style={{ whiteSpace: 'nowrap' }}>
          <span>{i18n.t('hint_time', 'Hinweiszeit')} </span>
          {!recommendedTimeFrom && (
            <span>
              {i18n.t('until_time_lowercase', 'bis')}{' '}
              <strong>{recommendedTimeUntil}</strong>
            </span>
          )}
          {!recommendedTimeUntil && (
            <span>
              {i18n.t('from_time_lowercase', 'ab')}{' '}
              <strong>{recommendedTimeFrom}</strong>
            </span>
          )}
          {recommendedTimeFrom && recommendedTimeUntil && (
            <span>
              {recommendedTimeFrom} - {recommendedTimeUntil}
            </span>
          )}
        </div>
      )}
      {requiresConfirmation && (
        <div className="mt-2">
          <FieldPrefix prefix="settings">
            <ConfirmationDetails />
          </FieldPrefix>
        </div>
      )}
    </Wrapper>
  )
}

export default TimeBlock
